import { observable } from "mobx";

export default class AgServicosStore {
    @observable cadastrando;
    @observable idEditando;
    @observable AgendGrupoServId;
    @observable AgendTipoServId;
    @observable Placa;
    @observable HoraAgend;
    @observable DatAgend;
    constructor() {
        this.cadastrando = false;
        this.idEditando = false;
        this.AgendGrupoServId = false;
        this.AgendTipoServId = false;
        this.Placa = false;
        this.HoraAgend = false;
        this.DatAgend = false;
        // this.cadastrando = true; // TODO Remover
        // this.idEditando = 27291; // TODO Remover // LEMA
        // this.idEditando = 22593; // TODO Remover // DECMA
        // this.idEditando = 27804; // TODO Remover // SVPES
        // this.idEditando = 27817; // TODO Remover // SVEXP
    };

    cadastrar = () => {
        this.cadastrando = true;
    };

    editar = (id, AgendGrupoServId, AgendTipoServId, Placa, HoraAgend, DatAgend) => {
        this.cadastrando = true;
        this.idEditando = id;
        this.AgendGrupoServId = AgendGrupoServId;
        this.AgendTipoServId = AgendTipoServId;
        this.Placa = Placa;
        this.HoraAgend = HoraAgend;
        this.DatAgend = DatAgend;
    };

    sairCadastrar = async () => {
        try
        {
            this.cadastrando = false;
            this.idEditando = false;
            await window.scrollTo(10, 10); // Bug da barra de rolagem com o cabeçalho do grid
        }
        catch(error)
        {
            console.log(error);
        }
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamentoservicos/agservicos/AgServicosStore.js